import FollowCommunities from "./followCommunities";

export default FollowCommunities;
